import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faPlusCircle,
	faTrashAlt,
	faExternalLinkAlt,
	faStarHalfStroke,
	faPenClip,
	faFilter,
} from '@fortawesome/free-solid-svg-icons'

import { faBlackTie } from '@fortawesome/free-brands-svg-icons'

import Loader from '@/components/Loader/index.vue'
import UserCard from '@/components/UserCard/index.vue'
import TabContent from './TabContent/index.vue'
import api from '@/helpers/fetch'

library.add(
	faPlusCircle,
	faExternalLinkAlt,
	faTrashAlt,
	faStarHalfStroke,
	faPenClip,
	faBlackTie,
	faFilter,
)

let sidebar;

@Component({
	components: {
		Loader,
		UserCard,
		TabContent,
	},
})
export default class Permissions extends Vue {
	loading = false;
	location = window.location;
	usersList = [] as Array<any>;
	currentTabUsersList = [] as Array<any>;
	tabsIndex = 0;
	tabs = [] as Array<any>;
	remainingHeight = '0px';

	filter = {
		name: '',
	}

	calcRemainingHeight() {
		this.remainingHeight = (window.innerHeight - (this.$refs.availableUsersInputWrapper as HTMLElement).getBoundingClientRect().bottom - 9) + 'px';
	}

	async mounted() {
		this.loading = true;
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath);
		const res = await api.get('/api/permissions/users');
		this.usersList.length = 0;
		this.usersList.push(...res.data.map(user => { user.loading = false; return user; }));

		const resGroups = await api.get('/api/permissions/roles');
		resGroups.data.forEach((role) => {
			this.tabs.push({ roleName: role.name, usersList: [], roleKey: role.key });
		});
		this.loading = false;

		this.calcRemainingHeight();
		window.addEventListener('resize', this.calcRemainingHeight);
	}

	beforeDestroy() {
		window.removeEventListener('resize', this.calcRemainingHeight);
	}

	updated() {
		if (sidebar) sidebar.updateSticky();
	}

	async addUser(user) {
		user.loading = true;
		const res = await api.post('/api/permissions/roles/' + this.tabs[this.tabsIndex].roleKey + '/addUser', { user: user.email });
		user.loading = false;
		if (res.ok) {
			this.tabs[this.tabsIndex].usersList.push(user);
			this.updateCurrentUsers(this.tabs[this.tabsIndex].roleKey);
		}
	}

	async removeUser(user) {
		const index = this.tabs[this.tabsIndex].usersList.findIndex((userIn) => userIn.id === user.id);
		// precisa ser uma referencia da array para ativar a reatividade
		this.tabs[this.tabsIndex].usersList[index].loading = true;
		const res = await api.delete('/api/permissions/roles/' + this.tabs[this.tabsIndex].roleKey + '/removeUser', { user: user.email });
		this.tabs[this.tabsIndex].usersList[index].loading = false;
		if (res.ok) {
			this.tabs[this.tabsIndex].usersList.splice(index, 1);
			this.updateCurrentUsers(this.tabs[this.tabsIndex].roleKey);
		}
	}

	updateCurrentUsers(tabKey) {
		if (this.tabs[this.tabsIndex].roleKey !== tabKey) return;
		this.currentTabUsersList = this.tabs[this.tabsIndex].usersList.map(user => user.id);
	}

	get availableUsers() {
		return this.usersList.filter((user) => {
			const notFound = !this.currentTabUsersList.find((userId) => userId === user.id);
			let queryIndex = 0;
			if (this.filter.name) {
				queryIndex = user.name.toLowerCase().indexOf(this.filter.name.toLowerCase());
			}

			return (notFound && queryIndex >= 0);
		})
	}
}
